import { createFileRoute, redirect } from '@tanstack/react-router'
import { GoLivePage } from '@/features/go-live'
import { FEATURE_FLAGS } from '@/config/feature-flags'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/go-live',
)({
  beforeLoad: () => {
    if (!FEATURE_FLAGS.GO_LIVE_ENABLED) {
      throw redirect({ to: '/organizations/settings/profile' })
    }
  },
  component: GoLivePage,
})
